module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-metals-remnants.a9a5e63f.png";